import React from 'react';
import PropTypes from 'prop-types';

const YesNoFlagRenderer = ({ value }) => {
  if (value === true) {
    return <span>Y</span>;
  }
  if (value === false) {
    return <span>N</span>;
  }

  return <span>{ value }</span>;
};

YesNoFlagRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
};

export default YesNoFlagRenderer;
